var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "emailConsultItem", class: _vm.classes },
    [
      _vm.isOpen
        ? [
            _c(
              "div",
              {
                ref: "emailConsultItemHeaderOpen",
                class: _vm.headerClasses,
                on: { click: _vm.handleHeaderClick }
              },
              [
                _c(
                  "div",
                  { staticClass: "email-consult__address-details" },
                  [
                    _c("CompassAvatar", {
                      attrs: {
                        size: "small",
                        initials: _vm.senderInitials,
                        avatarColorType: _vm.avatarColor(_vm.email.from.name)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "email-consult__address-details-wrapper" },
                      [
                        _c("div", { staticClass: "email-consult__sender" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "email-consult__sender-name typographies-paragraph-medium-semibold"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.email.from.name) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "email-consult__sender-email typographies-paragraph-small-regular"
                            },
                            [
                              _vm._v(
                                "\n                            (" +
                                  _vm._s(_vm.email.from.email) +
                                  ")\n                        "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "email-consult__recipients" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "email-consult__recipients-label"
                              },
                              [_vm._v(_vm._s(_vm.labelTo) + ":")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "email-consult__recipients-list",
                                class: { "is-expaned": _vm.isExpanded }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.formattedRecipients) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "email-consult__extra-information" }, [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "email-consult__sent-date typographies-paragraph-small-regular"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.formattedSentDate) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.attachmentCount > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "email-consult__attachments-count typographies-paragraph-small-semibold"
                          },
                          [
                            _c("CompassIcon", {
                              attrs: { size: "small", icon: "attachment" }
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.formattedAttachmentCount) +
                                "\n                    "
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "email-consult__actions" },
                    [
                      _c(
                        "CompassTooltip",
                        {
                          attrs: {
                            disabled: _vm.canSendEmail,
                            content: _vm.$t.__(
                              "email.EmailPanel.error_reconnect_email_account"
                            ),
                            placement: "bottom-end"
                          }
                        },
                        [
                          _c("CompassIconButton", {
                            attrs: {
                              icon: "reply",
                              size: "small",
                              disabled: !_vm.canSendEmail
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.handleReply($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "email-consult__content typographies-paragraph-medium-regular"
              },
              [
                _vm.hasRelatedObject
                  ? _c("EmailRelatedObject", {
                      attrs: { object: _vm.thread[0].linked_object }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "email-consult__content-text",
                  class: _vm.editorClass,
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.addBrToEmptyPragraphs(_vm.email.content)
                    )
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.attachmentCount > 0
              ? _c("div", { staticClass: "email-consult__attachments" }, [
                  _c(
                    "div",
                    { staticClass: "email-consult__attachments-summary" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "typographies-paragraph-medium-semibold"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.formattedAttachmentCount) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "email-consult__attachments-weight typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.formatBytes(_vm.attachmentsSize)) +
                              " au total)"
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "email-consult__attachments-list" },
                    _vm._l(_vm.email.attachments, function(attachment) {
                      return _c("EmailAttachmentLink", {
                        key: attachment.id,
                        attrs: { file: attachment }
                      })
                    }),
                    1
                  )
                ])
              : _vm._e()
          ]
        : [
            _c(
              "div",
              {
                class: _vm.headerClasses,
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.handleHeaderClick($event)
                  }
                }
              },
              [
                _c("CompassAvatar", {
                  attrs: {
                    size: "small",
                    initials: _vm.senderInitials,
                    avatarColorType: _vm.avatarColor(_vm.email.from.name)
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "email-consult__header--snippet-wrapper",
                    style: !_vm.isOpen ? "width: 100%" : ""
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "email-consult__header--snippet-information"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-consult__address-details-wrapper"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "email-consult__sender" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "email-consult__sender-name typographies-paragraph-medium-semibold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.email.from.name) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "email-consult__sender-email typographies-paragraph-small-regular"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                (" +
                                        _vm._s(_vm.email.from.email) +
                                        ")\n                            "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "email-consult__recipients" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "email-consult__recipients-label"
                                  },
                                  [_vm._v(_vm._s(_vm.labelTo) + ":")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "email-consult__recipients-list",
                                    class: { "is-expaned": _vm.isExpanded }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.formattedRecipients) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "email-consult__sent-date typographies-paragraph-small-regular"
                          },
                          [
                            _vm.attachmentCount > 0
                              ? _c("CompassIcon", {
                                  attrs: { size: "small", icon: "attachment" }
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.formattedSentDate) +
                                "\n                    "
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "email-consult__snippet",
                      domProps: { innerHTML: _vm._s(_vm.sanitizedSnippet) }
                    })
                  ]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }